"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../config");
var layout = function (props) {
    var after = props.after, before = props.before, children = props.children;
    var b = config_1.block("layout");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        before,
        react_1.default.createElement("div", { className: b() }, children),
        after));
};
exports.default = layout;
//# sourceMappingURL=index.js.map